import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import './collection.scss';

let classNames = require('classnames');

@inject('appStore', 'routerStore')
@observer
export class CollectionAbout extends Component {

    closeAbout() {
        const { appStore, routerStore, collection } = this.props;
        appStore.aboutOpen = false;

        if (collection) {
            routerStore.history.push(collection.Link);
        } else {
            routerStore.history.push('/');
        }
    }

    render() {
        const { collection, open } = this.props,
            classes = classNames({
                'collectionabout': true,
                'collectionabout--open': open
            });

        return <div className={classes}>
            <button className='pure-button pure-button--close' onClick={e => this.closeAbout()}>
                Close
            </button>
            <div className='collectionabout-container'>
                <div className='collectionabout-text' dangerouslySetInnerHTML={{ __html: collection.Content }} />
            </div>
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_collection/collection.about.js